import { MetaData } from './metadata';
import { Promotion } from './promotion';

export class PromotionDto {
    constructor(public metadata: MetaData, public results: Promotion[]) {}
}
